import React from 'react'
import "./Footer.css"
import {logosvg} from "../../constants"
function Footer() {
  return (
    <div className="App_Footer">
      <div className="Footer_container">
        <div className="Footer_header">
          <p className="Footer_title">
            Do you want to step in to the future before others
          </p>

          <button className="Footer-btn">
            Request Early Access
          </button>
        </div>

        <div className="Footer-links">
          <div className="Footer_box">
            <img src={logosvg} alt="logo" />
            <p className="Footer-para"> Crechterwoord K12 182 DK Alknjkcb,
              All Rights Reserved
            </p>
          </div>

          <div className="Footer-box">
            <h3 className="Footer-title">
              Links
            </h3>

            <nav>
              <ul>
                <li>
                  <a href = "#"> Overons </a>
                </li>
                <li>
                  <a href = "#"> Social Media </a>
                </li>
                <li>
                  <a href = "#"> Counters </a>
                </li>
                <li>
                  <a href = "#"> Contact </a>
                </li>
              </ul>
            </nav>
          </div>
          <div className="Footer-box">
            <h3 className="Footer-title">
          Company
            </h3>

            <nav>
              <ul>
                <li>
                  <a href="#">
                  Terms & Conditions
                  </a>
                </li>
                <li>
                  <a href="#">
                  Privacy Policy
                  </a>
                </li>
                <li>
                  <a href = "#"> Careers </a>
                </li>  
              </ul>
            </nav>
          </div>
          <div className="Footer-box">
            <h3 className="Footer-title">
              Get in touch
            </h3>

            <nav>
              <ul>
                <li>
                  <a href="#">
                Moyo K12 182 DK Uganda
                  </a>
                </li>
                <li>
                  <a href="#">
                    info@payme.net
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <p className="copyright">
          @2022 GPT-3. All rights reserved.
        </p>
      </div>
    </div>
  )
}

export default Footer